import { Button } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import { HeaderDialog } from 'components';
import CreatePositionsForm from 'containers/settings/positions/forms/create-position-form/CreatePositionForm';
import { useOpenable } from 'hooks';
import { t } from 'utils/localize';

export interface ICreatePositionButtonProps {
  highestLevel: number;
  className?: ClassName;
  onCreate: () => void;
}

const CreatePositionButton = ({ className, highestLevel, onCreate }: ICreatePositionButtonProps) => {
  const createPositionOpenable = useOpenable();
  const classes = classNames('create-position-button', className);

  function onSubmit() {
    onCreate();
    createPositionOpenable.close();
  }
  return (
    <>
      <Button className={classes} onClick={createPositionOpenable.open} type="primary">
        {t('Create Position')}
      </Button>
      <HeaderDialog
        title={t('Create Position')}
        divider={false}
        isOpen={createPositionOpenable.isOpen}
        onClose={createPositionOpenable.close}
      >
        <CreatePositionsForm level={highestLevel} onSubmit={onSubmit} className="mx-8 my-4" />
      </HeaderDialog>
    </>
  );
};

export default CreatePositionButton;
